import React from 'react';

import { HeadProps } from 'gatsby';

import { localeBaseUrl } from '../../libs/alternative-links';
import { GlobalPageContext } from '../types';

export const Head = ({
  location,
  pageContext: {
    name,
    title,
    description,
    keywords,
    alternatives,
    locale,
    lang,
  },
}: HeadProps<unknown, GlobalPageContext>) => (
  <>
    <html lang={lang} />
    <title>{title || name}</title>
    {description && <meta name="description" content={description} />}
    {keywords && <meta name="keywords" content={keywordsString(keywords)} />}
    <link
      rel="canonical"
      href={localeBaseUrl(locale, true) + location.pathname}
    />
    {alternatives?.map((a) => (
      <link key={a.locale} rel="alternate" hrefLang={a.locale} href={a.href} />
    ))}
  </>
);

const keywordsString = (keywords: string[]): string => keywords.join(',');
